module.exports = __webpack_public_path__ + "static/media/rsvp-1920.dbdad66a.jpg";